export function generateVersion4GUID(): string {
	const uuidVariant = ((((Math.random() * 16) | 0) & 0x3) | 0x8).toString(16);
	return `${getRandomString(8)}-${getRandomString(4)}-4${getRandomString(3)}-${uuidVariant}${getRandomString(
		3
	)}-${getRandomString(12)}`;
}

function getRandomString(length: number): string {
	return Array.from({ length }, () => ((Math.random() * 16) | 0).toString(16)).join("");
}
